import { Button, cn, Stack } from '@prenuvo/halo';

import { PatientDocLink } from '../../patient-docs-side-panel.model';
import { ExternalDocumentLink } from './external-document-link.component';

interface DocumentActionsProps {
  link: PatientDocLink;
  onOpenDocument: () => void;
}

export function DocumentActions({ link, onOpenDocument }: DocumentActionsProps) {
  return (
    <Stack alignment="center" gap={3}>
      <Button
        aria-label={`View Document with url of ${link.url}`}
        className={{
          root: cn([
            'border dark:bg-stone-800',
            'hover:dark:border-neutral-700 hover:dark:bg-neutral-700 hover:dark:text-neutral-100',
            'active:dark:border-neutral-800 active:dark:bg-neutral-800 active:dark:text-neutral-100',
          ]),
        }}
        onClick={onOpenDocument}
        size="xs"
        translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENTS.ACTIONS.VIEW"
        variant="outlined"
      />

      <ExternalDocumentLink link={link} />
    </Stack>
  );
}
